import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AccountMaintenance from "@/pages/account/AccountMaintenance";

export const Route = createFileRoute("/account/maintenance")({
  head: () => pageHead("Account \u2014 Maintenance \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AccountMaintenance,
});
